import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filterscoopReport: [],
    filterscoopReportStats: [],
    filterjobsReport: [],
    filterInvoiceReport: [],
    filterLinguistReport: [],
    margin_report: [],
    client_invoice_view: [],
    linguist_invoice_view: [],
    show_invoice_setting: [],
    project_statistics: [],
    project_statistics_linguist: [],
    scoop_project_filter_search: [],
    invoice_with_settings: [],
    freelance_invoice_with_settings: [],
    filterjobsReportOptions: [],
    advance_project_search: [],
    advance_project_search_filters: [],
}

const ReportSlice = createSlice({
    name: "ReportSlice",
    initialState,
    reducers: {
        setScoopReport: (state, action) => ({
            ...state,
            filterscoopReport: action.payload
        }),
        setScoopReportStats: (state, action) => ({
            ...state,
            filterscoopReportStats: action.payload
        }),
        setJobReport: (state, action) => ({
            ...state,
            filterjobsReport: action.payload
        }),
        setJobsFromTmsSummeryViewSearch: (state, action) => ({
            ...state,
            filterjobsReportOptions: action.payload
        }),
        setInvoiceReport: (state, action) => ({
            ...state,
            filterInvoiceReport: action.payload
        }),
        setLinguistReport: (state, action) => ({
            ...state,
            filterLinguistReport: action.payload
        }),
        setMarginReport: (state, action) => ({
            ...state,
            margin_report: action.payload
        }),
        setSingleClientInvoice: (state, action) => ({
            ...state,
            client_invoice_view: action.payload
        }),
        setSingleClientInvoiceLinguist: (state, action) => ({
            ...state,
            linguist_invoice_view: action.payload
        }),
        setInvoiceSetting: (state, action) => ({
            ...state,
            show_invoice_setting: action.payload
        }),
        setProjectStatistics: (state, action) => ({
            ...state,
            project_statistics: action.payload
        }),
        setProjectStatisticsLinguist: (state, action) => ({
            ...state,
            project_statistics_linguist: action.payload
        }),
        setScoopStatusDetails: (state, action) => ({
            ...state,
            scoop_project_filter_search: action.payload
        }),
        setInvoiceWithSettings: (state, action) => ({
            ...state,
            invoice_with_settings: action.payload
        }),
        setFreelanceInvoiceWithSettings: (state, action) => ({
            ...state,
            freelance_invoice_with_settings: action.payload
        }),
        setAdvanceSearchProjectScoopData: (state, action) => ({
            ...state,
            advance_project_search: action.payload
        }),
        setAdvanceSearchProjectScoopFilters: (state, action) => ({
            ...state,
            advance_project_search_filters: action.payload
        }),
    }
})

export const { setScoopReport, setScoopReportStats, setJobReport, setJobsFromTmsSummeryViewSearch, setInvoiceReport, setLinguistReport, setMarginReport, setSingleClientInvoice, setInvoiceSetting, setSingleClientInvoiceLinguist, setProjectStatistics, setProjectStatisticsLinguist, setScoopStatusDetails, setAdvanceSearchProjectScoopData, setInvoiceWithSettings, setFreelanceInvoiceWithSettings, setAdvanceSearchProjectScoopFilters } = ReportSlice.actions;

export default ReportSlice.reducer;